/**
 * メニューリンク
 */
export type MenuLink = {
  name: string;
  url: string;
};

/**
 * パスワード忘れはこちらのURL
 */
export const passwordChangeLink: MenuLink = {
  name: 'パスワード忘れはこちら',
  url: 'https://forms.office.com/r/rp7xKngpRA',
};

/**
 * 静的リンクの設定
 */
export const StaticLinks: MenuLink[] = [
  {
    name: '問合せ（ユーザー情報）',
    url: 'https://forms.office.com/r/ZsuXNVZW1F',
  },
  {
    name: '問合せ（データ等情報）',
    url: 'https://forms.office.com/r/EuN0GXyCg8',
  },
  {
    name: 'ダッシュボード',
    url: 'https://dsbd.takanawagateway-sc.com',
  },
];
